export default class Dropdown {
	/**
	 * Create a new instance of a Dropdown
	 * @param {HTMLElement} element - The element of the dropdown
	 */
	constructor(element) {
		this.element = element;
		this.elements = {
			button: this.element.querySelector(".js-Dropdown-button"),
			dropdown: this.element.querySelector(".js-Dropdown-list"),
			options: this.element.querySelectorAll(".js-Dropdown-option"),
			announcement: this.element.querySelector(".Dropbox-announcement"),
			tags: this.element.querySelector(".js-Dropdown-tags"),
			label: this.element.querySelector(".js-Dropdown-label"),
		};

		this.isDropdownOpen = false;
		this.currentOptionIndex = 0;
		this.lastTypedChar = "";
		this.lastMatchingIndex = 0;
		this.activeClass = "is-active";
		this.currentClass = "is-current";
		this.labelClass = "js-Dropdown-label";

		this.handleKeyPress = this.handleKeyPress.bind(this);
		this.handleDocumentInteraction = this.handleDocumentInteraction.bind(this);

		this.elements.button.addEventListener("keydown", this.handleKeyPress);
		document.addEventListener("click", this.handleDocumentInteraction);
	}

	/**
	 * Toggles the dropdown active state
	 */
	toggleDropdown() {
		this.elements.dropdown.classList.toggle(this.activeClass);
		this.isDropdownOpen = !this.isDropdownOpen;
		this.elements.button.setAttribute(
			"aria-expanded",
			this.isDropdownOpen.toString(),
		);

		if (this.isDropdownOpen) {
			this.focusCurrentOption();
		} else {
			this.elements.button.focus();
		}
	}

	/**
	 * Handles key press events on the dropdown
	 * @param {KeyboardEvent} event - The keyboard event
	 */
	handleKeyPress(event) {
		event.preventDefault();
		const { key } = event;
		const openKeys = ["ArrowDown", "ArrowUp", "Enter"];

		if (!this.isDropdownOpen && openKeys.includes(key)) {
			this.toggleDropdown();
		} else if (this.isDropdownOpen) {
			switch (key) {
				case "Escape":
					this.toggleDropdown();
					break;
				case "ArrowDown":
					this.moveFocusDown();
					break;
				case "ArrowUp":
					this.moveFocusUp();
					break;
				default:
					break;
			}
		}
	}

	/**
	 * Handles interactions with the document, such as clicks
	 * @param {Event} event - The Event object
	 */
	handleDocumentInteraction(event) {
		const isClickInsideButton = this.elements.button.contains(event.target);
		const isClickInsideDropdown = this.elements.dropdown.contains(event.target);

		if (
			isClickInsideButton ||
			(!isClickInsideDropdown && this.isDropdownOpen)
		) {
			this.toggleDropdown();
		}
	}

	/**
	 * Moves the focus down to the next dropdown option
	 */
	moveFocusDown() {
		if (this.currentOptionIndex < this.elements.options.length - 1) {
			this.currentOptionIndex += 1;
		} else {
			this.currentOptionIndex = 0;
		}
		this.focusCurrentOption();
	}

	/**
	 * Moves the focus up to the previous dropdown option
	 */
	moveFocusUp() {
		if (this.currentOptionIndex > 0) {
			this.currentOptionIndex -= 1;
		} else {
			this.currentOptionIndex = this.elements.options.length - 1;
		}
		this.focusCurrentOption();
	}

	/**
	 * Focuses on the current dropdown option
	 */
	focusCurrentOption = () => {
		const currentOption = this.elements.options[
			this.currentOptionIndex
		].querySelector(`.${this.labelClass}`);

		currentOption.classList.add(this.currentClass);
		currentOption.focus();

		// Scroll the current option into view
		currentOption.scrollIntoView({
			block: "nearest",
		});

		this.elements.options.forEach((option) => {
			if (option !== currentOption) {
				option.classList.remove(this.currentClass);
			}
		});
	};
}
